import React, { Component } from 'react';
import ReactLoading from 'react-loading';
import tr from '../../../libs/tr';
import { getSkierMovementsFetch } from '../../../libs/fetch';
import './MovSubPnl.css';
import MovMinSubPnl from "./MovMinSubPnl";
import FullViewBar from "./FullViewBar";
//import { array } from 'prop-types';
//import { AlertAddAlert } from 'material-ui/svg-icons';

class MovSubPnl extends Component {

    constructor(props) {
        super(props);
        // console.log("props", props);
        console.log("props in [MovSubPnl] 2: rendering after click on skier in rows", props);

        this.state = {
            isLoading: false,
            yearView: true,
            monthView: false,
            fullView: false,
            Alertf: false,
            laodedData: false,
            activeYear: '',
            activeMonth: '',
            activeSkier: props.activeSkier,
            movements: '',

        };

        this.textname = props.activeSkier ? (props.activeSkier.name + ' ' + props.activeSkier.surname) : "Text missing!";

        this.onClick = this.onClick.bind(this);
        this.changeview1 = this.changeview1.bind(this);
        this.changeview2 = this.changeview2.bind(this);
        this.onAlert = this.onAlert.bind(this);
    }

    componentDidMount() {
        this.getSkierMovements();
    }

    changeview1 = (year) => {
        this.forceUpdate(() => {
            console.log('changeview1 year:', year);

            this.setState({
                yearView: !this.state.yearView,
                monthView: !this.state.monthView,
                activeYear: year
            })
        });

    }

    changeview2 = (month) => {
        console.log('changeview2 month:', month);
        this.forceUpdate(() => {
            this.setState({
                monthView: !this.state.monthView,
                fullView: !this.state.fullView,
                activeMonth: month
            })
        });
    }

    onClick = () => {
        this.props.onClick();
    }
    onAlert = () => {
        this.props.onAlert();
    }
    ///service/getSkierMovements
    getSkierMovements = () => {
        this.setState({ isLoading: true });
        let params = {
            linked_user_id: this.state.activeSkier.id
        }

        try {
            getSkierMovementsFetch(this, params).then((response) => {
                this.setState({ isLoading: false });
                console.log("getSkierMovementsFetch", response);
                if (response.status === "fail")
                    return this.setState({ loadedData: true, movements: [] });
                this.setState({ loadedData: true, movements: response });

            })
        } catch (e) {
            console.error(e);
        }
    }


    // TODO
    // move this functions to utils.js

    // @return array w/ keys of json
    jsonKeysToArray = (json) => {
        let array = [];

        Object.keys(json).forEach(function (key) {
            array.push(key);
        });

        return array;
    }


    // convert numeric month in translated Month 
    intMonthToString = (month) => {
        switch (parseInt(month)) {
            case 1:
                return tr.t("January")
            case 2:
                return tr.t("February")
            case 3:
                return tr.t("March")
            case 4:
                return tr.t("April")
            case 5:
                return tr.t("May")
            case 6:
                return tr.t("June")
            case 7:
                return tr.t("July")
            case 8:
                return tr.t("August")
            case 9:
                return tr.t("September")
            case 10:
                return tr.t("October")
            case 11:
                return tr.t("November")
            case 12:
                return tr.t("December")

        }

    }

    // render loop for years movement
    // @render n. years MovMinSubPnl
    renderYearsMovements = (that) => {
        if (this.state.movements.length == 0)
            return (
                <div className="sn_ua__container text-center">{tr.t("NoMovement")}</div>
            )
        let years = this.jsonKeysToArray(this.state.movements);
        console.log(years);
        return years.map(function (year, index) {
            console.log(year);
            return <MovMinSubPnl
                key={index}
                index={index}
                year={year}
                textym={tr.t("Passyear")}
                onClick={that.changeview1.bind(that, year)}
                callback={that.changeview1.bind(that, year)} />
        });

    }

    // render loop for years movement
    // @render n. years MovMinSubPnl
    renderMonthMovements = (that) => {

        let months = this.jsonKeysToArray(this.state.movements[this.state.activeYear]);
        console.log('renderMonthMovements', months);
        return months.map(function (month, index) {
            console.log(month);
            return <MovMinSubPnl
                key={index}
                index={index}
                year={that.state.activeYear}
                textym={that.intMonthToString(month)}
                onClick={that.changeview2.bind(that, month)}
                callback={that.changeview2.bind(that, month)} />
        }, this);

    }


    // render loop for movement detail
    // @render 
    renderMovementDetails = (that) => {
        let detail = this.jsonKeysToArray(this.state.movements[this.state.activeYear][this.state.activeMonth]);
        return detail.map(function (index) {
            let movement = that.state.movements[that.state.activeYear][that.state.activeMonth][index];
            console.log('renderMovementDetails movement', movement);
            let date = movement.dateFrom.split(' ')[0];
            let movement2 = {
                date: date.split('-')[2] + '/' + date.split('-')[1] + '/' + date.split('-')[0],
                fullname: '',
                skiresort: movement.comprensorio,
                cost: movement.val_accesso,
                duration: datesToTime(movement.dateFrom, movement.dateTo),
                Cardtypelast: movement.descrizione,
                alert: (movement.paid == 0),
            };
            return <FullViewBar
                allMovements={false}
                key={index}
                index={index}
                movement={movement2}
                // textlast={movement.comprensorio}
                onAlert={that.onAlert.bind(that)}
            />
        }, that);

    }

    render() {
        return (

            <div className="containerSubmovmainPnl">
                {this.state.isLoading && <ReactLoading className="loading" type={'bars'} />}

                {this.state.loadedData && !this.state.isLoading && <div>
                    
                    
                    {this.state.yearView ?
                        <div>
                            <div className="d-flex align-items-center">
                              <button className="arrowbBtn mr-3" onClick={this.onClick}></button>
                              <div className="movsubfullName" style={{ flex: 1 }}>
                                  {this.textname}
                              </div>
                            </div>
                            {this.renderYearsMovements(this)}
                            {/*<MovMinSubPnl textym={tr.t("Passyear")} onClick={this.changeview1} />*/}
                        </div> : null
                    }

                    {this.state.monthView ?
                        <div>
                            <div className="d-flex align-items-center">
                              <button className="arrowbBtn mr-3" onClick={this.changeview1}></button>
                              <div className="movsubfullName" style={{ flex: 1 }}>
                                  {this.textname}
                              </div>
                            </div>
                            {this.renderMonthMovements(this)}
                            {/*
                            <MovMinSubPnl textym={tr.t("December")} onClick={this.changeview2} />
                            <MovMinSubPnl textym={tr.t("November")} onClick={this.changeview2} />
                        */}
                        </div> : null
                    }

                    {this.state.fullView ?
                        <div>
                          <div className="d-flex align-items-center">
                            <button className="arrowbBtn mr-3" onClick={this.changeview2}></button>
                            <div className="movsubfullName" style={{ flex: 1 }}>
                                {this.textname}
                            </div>
                          </div>
                          <div className="fullViewPnl" style={{ flex: 1 }}>
                              {this.renderMovementDetails(this)}
                              {/*

                          <FullViewBar textlast={this.textname} />
                          <FullViewBar textlast={this.textname} />
                          <FullViewBar textlast={this.textname} />
                          <FullViewBar textlast={this.textname} />
                      */}
                          </div>
                          {this.state.Alertf ?
                              <div>
                                  <button className="bbtnfv">{tr.t("Retrypayment")}</button>
                              </div> : null
                          }
                      </div> : null
                    }
                </div>}
            </div>
        );
    }
}

export default MovSubPnl;

function datesToTime(startDate, endDate) {
    console.log("datesToTime : ",startDate, " , " , endDate);
    let startDateArray = startDate.replace(/[\s]+/g, '-').replace(/[:]+/g, '-').split('-');
    let endDateArray = endDate.replace(/[\s]+/g, '-').replace(/[:]+/g, '-').split('-');
    console.log("datesToTime 1: ",startDateArray);
    console.log("datesToTime 2: ",endDateArray);

    var d1 = new Date(startDateArray[0],startDateArray[1],startDateArray[2],startDateArray[3],startDateArray[4],startDateArray[5]).getTime();
    var d2 = new Date(endDateArray[0],endDateArray[1],endDateArray[2],endDateArray[3],endDateArray[4],endDateArray[5]).getTime();
    console.log("datesToTime d1: ",d1);
    console.log("datesToTime d2: ",d2);
    var hh = parseInt((d2 - d1) / 3600000);
    var mm = parseInt(((d2 - d1) % (hh * 3600000)) / 60000);
    var ss = ((d2 - d1) % 60000) / 1000;
    let time = hh.toString().padStart(2, "0") + ':' + mm.toString().padStart(2, "0") + ':' + ss.toString().padStart(2, "0");
    return time
}


// WEBPACK FOOTER //
// ./src/assets/components/panel/MovSubPnl.js